<p-card data-variant="compact">
  <p-table [value]="advances()" dataKey="id" [rowHover]="true" [loading]="isLoading()">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'EmployeeAdvance_Col_Number' | translateWF: 'Number' }}</th>
        <th class="text-right">{{ 'EmployeeAdvance_Field_Amount' | translateWF: 'Amount' }}</th>
        <th>{{ 'Status' | translateWF: 'Status' }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      @let row = getRow(rowData);
      <tr>
        <td>
          <a class="cs-table-link font-mono" (click)="open(row)">{{ row.number }}</a>
          <small class="block text-surface-500">{{ row.advanceDate | date: 'dd/MM/yyyy' : 'UTC' }}</small>
        </td>
        <td class="text-right tabular-nums">
          {{ symbolOf(row.currency) }} {{ row.amount | number: '1.2-2' }}
          @if (row.status === 2 && row.outstanding < row.amount) {
            <small class="block text-surface-500">{{ 'EmployeeAdvance_Outstanding' | translateWF: 'Still to net' }} {{ row.outstanding | number: '1.2-2' }}</small>
          }
        </td>
        <td><p-tag [severity]="statusSeverity(row.status)" [value]="statusLabel(row.status)" /></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3" class="text-center">{{ 'EmployeeAdvance_Trip_None' | translateWF: 'No advances yet.' }}</td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
